// lbl.home
export const home = {
    welcome_point: {
        welcome: 'Welcome',
        you_have: 'You have',
        point_unit: 'plankton',
        expire: 'Plankton expired : ',
        my_coupon: 'My rewards',
    },
    member_code: {
        fill_code: 'For new user, please enter code here',
        fill_time: 'Enter code within : ',
        txt_minute: '',
        fill_here: 'Enter code',
        btn_confirm: 'Confirm',
        code: {
            name: 'Code',
            placeholder: 'Enter code',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    search_placeholder: 'Find your rewards',
    error_code: {
        400: {
            title: 'Code invalid',
            msg: 'Please check the code again',
        },
        404: {
            title: 'Code invalid',
            msg: 'Please check the code again',
        },
        409: {
            title: 'Code invalid',
            msg: 'Please check the code again',
        },
        2021: {
            title: 'Code invalid',
            msg: 'Please check the code again',
        },
        3002: {
            title: 'Code invalid',
            msg: 'Please check the code again',
        },
        1407: {
            title: '',
            msg: 'This code is applicable for promotion period only',
        },
    },
    tag_new: 'New',
    tag_popular: 'Popular'
};
